import DefaultLayout from '@/Layouts/DefaultLayout';
import { lazy } from 'react';
import { LoginRoutes } from '@/features/auth/routes/routes';
import { AuthInitializer } from '@/features/auth/guard/authInitializer';
import { StudentRealtionsRoutes } from '@/features/studentRelations/routes/routes';
import { OrderListRoutes } from '@/features/orders/routes/routes';
import { ServiceListRoutes } from '@/features/services/routes/routes';
import { HumanResourcesRoutes } from '@/features/humanResources/routes/routes';
import { BranchesRoutes } from '@/features/branch/routes/routes';
import { SettingRoutes } from '@/features/setting/routes/routes';
import { PermissionsRoutes } from '@/features/permissions/routes/routes';
import { ReportsRoutes } from '@/features/reports/routes/routes';
import { ProductsListRoutes } from '@/features/products/routes/routes';
import { FinanceRoutes } from '@/features/finance/routes/routes';
import { NotificationsRoutes } from '@/features/notifications/routes/routes';
import { StudentByTypeRoutes } from '@/features/students_by_type/routes/routes';
import { EnrollmentsRoutes } from '@/features/enrollments/routes/routes';
import { RouteErrorPage } from '@repo/ui/components/errors';

// ----------------------------------------------------------------------

const Home = lazy(() => import('@/core/global-pages/Home'));
const SoonPage = lazy(() => import('@/core/global-pages/SoonPage'));
const NotFound = lazy(() => import('@/core/global-pages/NotFound'));
const ServerError = lazy(() => import('@/core/global-pages/ServerError'));

// ----------------------------------------------------------------------

const routes = [
    {
        path: '/',
        element: (
            <AuthInitializer>
                <DefaultLayout />
            </AuthInitializer>
        ),
        errorElement: <RouteErrorPage />,
        children: [
            { index: true, element: <Home /> },
            {
                path: '/coming-soon',
                element: <SoonPage />,
                layout: 'default',
                isAuthReq: true,
            },
            {
                path: '/500',
                element: <ServerError />,
                layout: 'default',
                isAuthReq: true,
            },

            ...StudentRealtionsRoutes,
            ...OrderListRoutes,
            ...ServiceListRoutes,
            ...HumanResourcesRoutes,
            ...BranchesRoutes,
            ...SettingRoutes,
            ...PermissionsRoutes,
            ...ReportsRoutes,
            ...ProductsListRoutes,
            ...FinanceRoutes,
            ...NotificationsRoutes,
            ...StudentByTypeRoutes,
            ...EnrollmentsRoutes,
            { path: '*', element: <NotFound /> },
        ],
    },
    ...LoginRoutes,
    { path: '/500', element: <ServerError />, errorElement: <RouteErrorPage /> },
    { path: '*', element: <NotFound />, errorElement: <RouteErrorPage /> },
];
export { routes };
